import moment from 'moment';
export const DATE_FORMAT_API = 'YYYY-MM-DD';
export const DATE_FORMAT = 'DD/MM/YYYY';

export const DATETIME_FORMAT_FROM_API = 'YYYY-MM-DD HH:mm';
export const DATETIME_FORMAT = 'DD/MM/YYYY, HH:mm';
export const DATETIME_FORMAT_REVERSED = 'HH:mm DD/MM/YYYY';
export const DATETIME_FORMAT_FOR_TODAY = '[Today], HH:mm';
export const DATETIME_FORMAT_FOR_TODAY_REVERSED = 'HH:mm [today]';
export const MONTH_AND_YEAR_FORMAT = 'MMMM YYYY';
export const MONTH_FORMAT = 'MMMM'; //`January', 'February', etc.
export const DAY_MONTH_AND_YEAR_FORMAT = 'Do [of] MMMM, YYYY'; // formats date in `1st of March, 2019` format
export const TIME_FORMAT = 'HH:mm'; // formats 12:12 or 12:12

export const MONTH_DAY_YEAR_DATE_FORMAT = 'MM/DD/YYYY';
export const DATE_LOCALE = 'en-GB';

export const DAY_MONTH_YEAR_REGEX = /([0-3]?[0-9])\/(0[1-9]|1[0-2])\/([0-9]{4})/; // matches dates in 'DD/MM/YYYY' format

export const MONTH_DAY_YEAR_REGEX = /(0?[1-9]|1[0-2])\/(0?[0-9]|1[0-9]|2[0-9]|3[0-1])\/([0-9]{2})/; // matches dates in 'MM/DD/YYYY' format

export const formatDate = value => {
  return moment(value, DATE_FORMAT_API).format(DATE_FORMAT);
};

export const formatTime = value => {
  return moment(value, DATETIME_FORMAT_FROM_API).format(TIME_FORMAT);
};

export const formatDateTime = value => {
  // Return moment in datetime format [11/11/2011, 12:12] or [Today, 12:12]
  const today = getTodayForApi();

  let format = DATETIME_FORMAT;

  const valueFormatForApi = moment(value).format(DATE_FORMAT_API);
  if (moment(valueFormatForApi).isSame(today)) {
    format = DATETIME_FORMAT_FOR_TODAY;
  }

  return moment(value, DATETIME_FORMAT_FROM_API).format(format);
};

export const formatTimeBeforeDate = value => {
  // Return moment in datetime format [12:12 11/11/2011] or [12:12 today]
  const today = getTodayForApi();

  let format = DATETIME_FORMAT_REVERSED;

  const valueFormatForApi = moment(value).format(DATE_FORMAT_API);
  if (moment(valueFormatForApi).isSame(today)) {
    format = DATETIME_FORMAT_FOR_TODAY_REVERSED;
  }

  return moment(value, DATETIME_FORMAT_FROM_API).format(format);
};

export const getDate = (dateString: string) =>
  moment(dateString, DATE_FORMAT).toDate();

export const getDateOrUndefined = (dateString: string) => {
  if (dateString) {
    return getDate(dateString);
  }
  return undefined;
};

export const getFormattedDateForApiOrValue = value =>
  isValidDate(value) ? formatDateForApi(value) : value;

export const isValidDate = value => DAY_MONTH_YEAR_REGEX.test(value);

export const formatDateOrEmptyString = value => {
  if (value) {
    return formatDate(value);
  }
  return '';
};

export const getCurrentMonthFirstDay = () => {
  return moment().startOf('month');
};

export const getCurrentMonthLastDay = () => {
  return moment().endOf('month');
};

export const getNextMonthFirstDay = date => {
  /* If date is month's first date, get current month's first day
     otherwise get next month's first day*/

  const currentMonthFirstDay = moment(date).startOf('month');
  const nextMonthFirstDay = moment(currentMonthFirstDay).add(1, 'month');

  // 'day' parameter will check if 'year', 'month' and 'day' are equal
  if (date.isSame(currentMonthFirstDay, 'day')) {
    return currentMonthFirstDay;
  }
  return nextMonthFirstDay;
};

export const getNextMonthLastDay = date => {
  const nextMonthFirstDay = getNextMonthFirstDay(date);
  return nextMonthFirstDay.endOf('month');
};

export const isDateValid = (value, strict = true) => {
  return !!value && moment(value, DATE_FORMAT, strict).isValid();
};

export const formatDateForApi = (value, strict = true) => {
  // true argument of moment indicates strict parsing of date formats
  if (isDateValid(value, strict)) {
    return moment(value, DATE_FORMAT).format(DATE_FORMAT_API);
  }
  return null;
};

export const getToday = () => moment().format(DATE_FORMAT);
export const getTodayForApi = () => moment().format(DATE_FORMAT_API);

export const getCurrentYearAndMonth = () =>
  moment().format(MONTH_AND_YEAR_FORMAT);

export const getCurrentDayMonthAndYear = () =>
  moment().format(DAY_MONTH_AND_YEAR_FORMAT);
